<template>
<div>
  <div v-if="dataExist">

    <div class="control-container">

      <div class="container-fluid">
        <div class="row">
          <div class="col-3" >
            <b-button-group>
              <b-dropdown right :text="displayModeText">
                <b-dropdown-item v-on:click.stop="enableTimelineDisplay()">Timeline</b-dropdown-item>
                <b-dropdown-item v-on:click.stop="enableTableDisplay()">Table</b-dropdown-item>
              </b-dropdown>
            <b-button v-b-toggle.collapse-1 variant="secondary" size="sm" >
              <font-awesome-icon icon="cog" style="margin-right: 12px"/>
              <font-awesome-icon icon="angle-down" class="d-none d-md-inline"/>
            </b-button>
            </b-button-group>
          </div>
          <div class="col-7 d-none d-md-block" >

              <b-badge class="mr-1" pill variant="secondary" v-for="item in itemTypes" :key="item.value">
                {{ item.label }}
              </b-badge>

          </div>
        </div>
      </div>

    </div>

    <b-collapse id="collapse-1" class="m-3">
      <b-card bg-variant="light">
        <b-form-group
            label-cols-lg="3"
            label="Options"
            label-size="lg"
            label-class="font-weight-bold pt-0"
            class="mb-0">

          <b-form-group
              label-cols-sm="3"
              label="Display Mode:"
              label-align-sm="right"
              label-for="nested-street">
            <b-form-select v-model="displayMode" :options="availableDisplayMode"></b-form-select>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Item Types:"
              label-align-sm="right" class="mb-0">
            <b-form-checkbox-group inline stacked
                                   v-model="itemTypes"
                                   :options="availableItemTypes"
                                   name="flavour-1a"></b-form-checkbox-group>
          </b-form-group>
        </b-form-group>
      </b-card>
    </b-collapse>



    <div class="container-fluid p-0 mt-2">
      <div v-if="showTimeline" class="timeline">
        <div class="timeline-month">
          Session Start - {{ startTime | moment("MMMM Do, YYYY, h:mm a")}}
        </div>
        <div class="timeline-section" v-for="item in timelineItems" :key="item.time">
          <div class="timeline-date">
            <span>{{ item.time | numeralFormat('00:00:00') }}</span>
          </div>
          <div class="row" >
            <div class="col-sm-4" v-for="mark in item.items" :key="mark.id">
              <div class="timeline-box" :style="mark.style">
                <div class="box-title">
                  <i class="fa" :class="mark.icon" /> {{ mark.name }}
                </div>
                <div class="box-content">
                  <div v-if="mark.hasValue" class="box-item"><strong>Value</strong>: {{ mark.value }}</div>
                  <div class="box-item" v-for="(part, index) in mark.detailItems" :key="`markpart-${index}`">{{ part }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="timeline-month">
          End - {{ endTime | moment("MMMM Do, YYYY, h:mm a")}}
        </div>
      </div>
      <div v-else>
        <vue-good-table
            styleClass="vgt-table condensed bordered striped"
            :columns="tableColumns"
            :rows="tableRows"
            :line-numbers="true"
            :fixed-header="false"
            :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPage: 60,
                            dropdownAllowAll: false,
                            perPageDropdown: [60, 120, 240, 500, 1000, 2500],
                        }"
            >
          <template slot="table-column" slot-scope="props">
            <span class="data-column-header">
              {{props.column.label}}
            </span>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'time'">
              <span>{{props.row.time | numeralFormat('00:00:00')}}</span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
          <div slot="table-actions" class="mx-2">
            <b-button variant="outline-secondary" size="sm" class="m-1" @click="downloadTable">
              <font-awesome-icon icon="file-download"/>
            </b-button>
          </div>
        </vue-good-table>
      </div>
    </div>

  </div>
  <div v-else class="text-center">
    <h5>No Timeline data available.</h5>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import dataTableUtil from "../../lib/DataTableUtil"
import sessionLogItemTypes from "../../lib/SessionLogItemTypes"
import vo2DeviceErrors from "../../lib/VO2DeviceErrorTypes"
import moment from "moment";

export default {
  name: "SessionTimelineTab",
  props: [ ],
  data() {
    return {
      isBusy: false,

      displayMode: '',
      itemTypes: [],

      tableColumns: [
        {
          label: 'Time',
          field: 'time',
          sortable: true,
          thClass: 'data-column-header',
        },
        {
          label: 'Type',
          field: 'type',
          sortable: true,
          thClass: 'data-column-header',
        },
        {
          label: 'Value',
          field: 'value',
          sortable: true,
          thClass: 'data-column-header',
        },
        {
          label: 'Detail',
          field: 'detail',
          sortable: false,
          thClass: 'data-column-header',
        },
      ],

    }
  },
  created () {
    this.refreshDisplayMode();
    this.refreshItemTypes();
  },
  watch: {

    itemTypes: {
      handler: function (newValue) {
        if (newValue && this.selectedItemTypes !== newValue) {
          this.changeItemTypes(newValue);
        }
      }
    },
    displayMode: {
      handler: function (newValue) {
        if (newValue && this.selectedDisplayMode !== newValue) {
          this.changeDisplayMode(newValue);
        }
      }
    },
  },
  computed: {
    ...mapGetters({

      session: 'session/current',

      measurementDataLoading: 'measurement/isLoading',
      measurementData: 'measurement/current',

      selectedItemTypes: 'timeLine/selectedItemTypes',
      availableItemTypes: 'timeLine/availableItemTypes',
      selectedDisplayMode: 'timeLine/selectedDisplayMode',
      availableDisplayMode: 'timeLine/availableDisplayMode',

    }),

    showTimeline: function() {
      return this.selectedDisplayMode == 'Timeline';
    },
    displayModeText: function() {
      return this.selectedDisplayMode;
    },

    startTime: function() {
      return this.session ? this.session.startTime : '';
    },
    endTime: function() {
      return this.session ? this.session.endTime : '';
    },
    elapsedSeconds: function () {
      if (this.measurementData && this.measurementData.elapsedSeconds) {
        return this.measurementData.elapsedSeconds;
      }

      return 0
    },
    dataExist: function () {
      return this.measurementData && this.measurementData.logData && this.measurementData.logData.length > 0;
    },

    tableRows: function() {

      let rows = [];

      for(let group of this.timelineItems) {
        for(let item of group.items) {
          let row = { time: group.time };
          row['type'] = item.name;
          row['value'] = item.value ?? '';
          if(item.detailItems.length > 0) {
            row['detail'] = item.detailItems.join(', ');
          } else {
            row['detail'] = item.detail ?? '';
          }
          rows.push(row);
        }
      }

      return rows;
    },

    timelineItems: function () {

      if (!this.dataExist)
        return [];

      let self = this;
      let index = 0;
      let groupMap = new Map();
      this.measurementData.logData.forEach(function (logItem) {

        let t = 0;
        if(logItem.time !== undefined)
          t = logItem.time;
        else if(logItem.t !== undefined)
          t = logItem.t;
        else
            return;

        t = Math.floor(t / 1000); //ms to seconds
        let i = {
          id: index++,
          time: t,
          type: logItem.type,
          value: logItem.value !== undefined ? logItem.value : logItem.v,
          detail: logItem.detail !== undefined ? logItem.detail : logItem.d,
        };
        i.detailItems = [i.detail];

        if(self.filterItem(i)) {
          i = self.processLogItem(i);
          if (i) {
            if (groupMap.has(i.time)) {
              groupMap.get(i.time).items.push(i);
            } else {
              groupMap.set(i.time, {
                time: i.time,
                items: [i]
              });
            }
          }
        }
      });

      let result = Array.from(groupMap.values());

      result.sort((a, b) => a.time - b.time);

      return result;
    },
  },
  methods: {
    ...mapActions({

      changeDisplayMode: 'timeLine/changeDisplayMode',
      changeItemTypes: 'timeLine/changeItemTypes',
    }),

    refreshDisplayMode: function() {
      let value = this.selectedDisplayMode;
      if(value && this.displayMode !== value) {
        this.displayMode = value;
      }
    },
    refreshItemTypes: function() {
      let value = this.selectedItemTypes;
      if(value && this.itemTypes !== value) {
        this.itemTypes = value;
      }
    },

    filterItem(logItem) {

      if(logItem.type == sessionLogItemTypes.SessionBindDevice ||
          logItem.type == sessionLogItemTypes.SessionUnBindDevice ||
          logItem.type == sessionLogItemTypes.SessionScanStart ||
          logItem.type == sessionLogItemTypes.SessionScanStop ||
          logItem.type == sessionLogItemTypes.SessionDevicesChanged ) {
        return null; //ignore these types
      }

      let itemType = sessionLogItemTypes.find(logItem.type);
      if(itemType && itemType.category) {
        return this.selectedItemTypes.find(x => x.value == itemType.category);
      } else {
        return this.selectedItemTypes.find(x => x.value == sessionLogItemTypes.CategoryOther);
      }
    },

    processLogItem(logItem) {

      if(!logItem)
        return null;

      logItem.hasValue = logItem.value !== undefined ? true : false;

      let itemType = sessionLogItemTypes.find(logItem.type);
      if(itemType) {
        logItem.name = itemType.label;
        logItem.style = { backgroundColor: itemType.color };
        logItem.icon = itemType.icon;
      } else {
        logItem.name = logItem.type;
        logItem.icon = 'fa-info';
      }

      if(logItem.type == sessionLogItemTypes.SessionMarkNumber) {
        logItem.name = 'Mark - ' + (logItem.details ?? ['']).find(x => x != null);
      } else if(logItem.type == sessionLogItemTypes.ProtocolStepChanged) {
        this.parseProtocolStep(logItem);
      } else if(logItem.type == sessionLogItemTypes.SessionPause) {
        this.parseSessionStatus(logItem);
      } else if(logItem.type == sessionLogItemTypes.SessionRecording) {
        this.parseSessionStatus(logItem);
      } else if(logItem.type == sessionLogItemTypes.SessionComplete) {
        this.parseSessionStatus(logItem);
      } else if(logItem.type == sessionLogItemTypes.DeviceError) {
        this.parseDeviceError(logItem);
      }

      return logItem;
    },

    parseProtocolStep(logItem) {
      if(!logItem.detail || !logItem.detail.length) {
        return;
      }
      let texts = logItem.detail.split(" ");
      if(texts.length > 0) {
        logItem.detailItems = [];
        for (let part of texts) {
          if (part.startsWith('id:')) continue;
          logItem.detailItems.push(part);
        }
      }
    },

    parseSessionStatus(logItem) {
      if(logItem.hasValue && this.startTime) {
        logItem.detailItems = [moment(this.startTime).add(logItem.value, 'seconds').format("MMMM Do, h:mm:ss a")];
      }
    },

    parseDeviceError(logItem) {
      if(logItem.hasValue) {
        let deviceError = vo2DeviceErrors.find(logItem.value);
        logItem.detailItems = [deviceError.detail];

        if(deviceError.category == vo2DeviceErrors.fatalCategory) {
          logItem.icon = 'fa-fire';
        } else if(deviceError.category == vo2DeviceErrors.warningCategory) {
          logItem.icon = 'fa-exclamation-triangle';
        } else {
          logItem.icon = 'fa-info';
        }

      }
    },

    enableTimelineDisplay() {
      this.displayMode = 'Timeline';
    },
    enableTableDisplay() {
      this.displayMode = 'Table';
    },

    downloadTable() {
      let csv = dataTableUtil.toCSV(this.tableColumns, this.tableRows);
      dataTableUtil.beginDownload("Datatable.csv", csv);
    },

  },

}
</script>

<style scoped>

.data-column-header {
  font-size: 12px;
  font-weight: bold;
}

.timeline{
  margin-top:10px;
  position:relative;
  padding: 8px;
  background-color: #e5e5e5;
  border-radius: 6px;
}

.timeline:before{
  position:absolute;
  content:'';
  width:4px;
  height:calc(100% - 15px);
  background: #343a40;
  left:107px;
  top:10px;
  border-radius:4px;
}

.timeline-month{
  position:relative;
  padding:4px 35px 4px 35px;
  background-color:#f4f5f8;
  display:inline-block;
  width:auto;
  border-radius:6px;
  border:1px solid #343a40;
  margin-bottom:15px;
  font-size: small;
}

.timeline-section{
  padding-left:120px;
  display:block;
  position:relative;
  margin-bottom:10px;

  border-width: 1px;
  border-bottom: dashed #cccccc;
}

.timeline-date{
  margin-bottom:15px;
  margin-left: -120px;
  padding:2px 15px;
  background: #f4f5f8;
  position:relative;
  display:inline-block;
  border-radius:6px;
  border:1px solid #343a40;

  font-size: small;
}
.timeline-section:before{
  content:'';
  position:absolute;
  width:30px;
  height:1px;
  background-color:#444950;
  top:12px;
  left:70px;
}

.timeline-section:after{
  content:'';
  position:absolute;
  width:12px;
  height:12px;
  background: #f4f5f8;
  top:7px;
  left:95px;
  border:1px solid #17191B;
  border-radius:100%;
}

.timeline-section .col-sm-4{
  margin-bottom:20px;
}

.timeline-section .col-sm-3{
  margin-bottom:10px;
}

.timeline-box{
  position:relative;

  color: #fff;
  background-color:#1a96d3;
  border-radius:6px;
  border-top-left-radius:0px;
  border-top-right-radius:0px;
  border:1px solid #17191B;
  transition:all 0.3s ease;
  overflow:hidden;
  margin-top: -25px;
  margin-bottom: 15px;
}

.box-icon{
  position:absolute;
  right:5px;
  top:0px;
}

.box-title{
  padding: 4px 8px;
  font-size: small;

}

.box-title i{
  margin-right:5px;
}

.box-content{
  padding: 0px 6px;
  background-color:#f4f5f8;
  color: #333;
  font-size: small;
}

.box-content strong{
  margin-right:8px;
}

.box-item{
  margin-bottom:0px;
  max-width: 200px;
}

.control-container {
  background-color: #f2f2f2;
  padding: 8px;
  border-radius: 6px;
}

</style>